import React, { useState } from 'react';
import BaseModal from './BaseModal';
import TooltipIconTrigger from './TooltipIconTrigger';

type IconTooltipModalProps = Readonly<{
  tooltip: React.ReactNode;
  triggerAriaLabel: string;
  triggerIcon: React.ReactNode;
  modalTitle: React.ReactNode;
  children: React.ReactNode;
  modalClassName?: string;
  dialogClassName?: string;
  closeAriaLabel?: string;
  tooltipDelay?: number;
}>;

export default function IconTooltipModal(props: IconTooltipModalProps) {
  const {
    tooltip,
    triggerAriaLabel,
    triggerIcon,
    modalTitle,
    children,
    modalClassName,
    dialogClassName,
    closeAriaLabel,
    tooltipDelay,
  } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <TooltipIconTrigger
        onPress={() => setIsOpen(true)}
        ariaLabel={triggerAriaLabel}
        tooltip={tooltip}
        tooltipDelay={tooltipDelay}
      >
        {triggerIcon}
      </TooltipIconTrigger>

      <BaseModal
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        title={modalTitle}
        modalClassName={modalClassName}
        dialogClassName={dialogClassName}
        closeAriaLabel={closeAriaLabel}
      >
        {children}
      </BaseModal>
    </>
  );
}
